
module.exports = [
	{
		code: 'frontpage',
		name: 'Startseite'
	}, {
		code: 'footer',
		name: 'Footer'
	}, {
		code: 'tos-agr',
		name: 'AGB AGR'
	}, {
		code: 'tos-sup',
		name: 'AGB SUP'
	}, {
		code: 'register-agr',
		name: 'Registrieren als Landwirt*in'
	}, {
		code: 'contact-page',
		name: 'Kontaktseite'
	}
]
